export const getBerthGroupsEndpoint = (tenantId: string, perPage: number = 100) =>
  `/berth-groups?tenant_id=${tenantId}&per_page=${perPage}` as const
